module.exports = __webpack_public_path__ + "img/45.88f93d88.jpg";